import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import GoogleAuth from "../../Assets/Images/GoogleAuth.png";
import "./SignupModal.css";
import "toastr/build/toastr.min.css";
// import toastr from "toastr";
// import axios from 'axios';
import {
  hasSpecialCharacter,
  isValidEmail,
  isValidName,
} from "../../Helpers/Utility";
import { toast } from "react-toastify";
import { postData } from "../../Services/Api";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-scroll";

export default function SignupModal({ show, handleClose, handleSignIn }) {
  const navigate = useNavigate(); // Initialize useNavigate

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (show == false) {
      setFormData({
        name: "",
        email: "",
        password: "",
        confirmpassword: "",
      });
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    const newErrors = {};
    if (formData.name.trim() === "") {
      newErrors.name = "Name is required";
    } else if (!isValidName(formData.name)) {
      newErrors.name = "Name should be more than 3 characters";
    }

    if (formData.email.trim() === "") {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (formData.password.trim() === "") {
      newErrors.password = "Password is required";
    } else if (
      formData.password.length < 6 ||
      !hasSpecialCharacter(formData.password)
    ) {
      newErrors.password =
        "Password must be at least 6 characters long and include at least one special character";
    }

    if (formData.confirmpassword.trim() === "") {
      newErrors.confirmpassword = "Confirm Password is required";
    } else if (formData.password !== formData.confirmpassword) {
      newErrors.confirmpassword = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const data = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        password_confirmation: formData.confirmpassword,
      };
      const postDataResponse = await postData("auth/register", data);

      if (postDataResponse.data.token !== "") {
        navigate("/#pricing");
        toast.success("Register successful!");
        setFormData({ name: "", email: "", password: "", confirmpassword: "" });
      } else {
        toast.error(postDataResponse.message);
      }
    } catch (error) {
      console.error("Error posting data:", error);
      toast.error("Error posting data. Please try again later.");
    }

    handleClose();
    setErrors({});
  };

  return (
    <Modal className="" show={show} onHide={handleClose} centered size="xl">
      <div className="position-absolute start-0 top-0 p-5 z-n1 greenOval rounded-circle"></div>
      <div className="container-fluid shadow-lg">
        <div className="row no-gutter">
          <div className="col-md-6 bg-white rounded-start-5">
            <div className="login py-5">
              <div className="card border-0 w-100 px-2 ps0 pe0">
                <div className="card-title text-center ">
                  <h3 className="p-3 pb-1">SIGN UP</h3>
                  <small className="text-secondary">
                    Create an account to get started
                  </small>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name*
                      </label>
                      <input
                        type="text"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        placeholder="Name"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <div className="text-danger">{errors.name}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email*
                      </label>
                      <input
                        type="email"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        placeholder="Email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password*
                      </label>
                      <input
                        type="password"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        id="password"
                        placeholder="Password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {errors.password && (
                        <div className="text-danger">{errors.password}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="confirmpassword" className="form-label">
                        Confirm Password*
                      </label>
                      <input
                        type="password"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        id="confirmpassword"
                        placeholder="Confirm Password"
                        name="confirmpassword"
                        value={formData.confirmpassword}
                        onChange={handleChange}
                      />
                      {errors.confirmpassword && (
                        <div className="text-danger">
                          {errors.confirmpassword}
                        </div>
                      )}
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="mb-0 form-check-input customFormText mx-2"
                        id="remember"
                      />
                      <label htmlFor="remember" className="mb-0 form-label">
                        Remember Me
                      </label>
                    </div>
                    <div className="d-grid">
                      <Button
                        type="submit"
                        className="btn btn-default startedBtn rounded-5 pt-2 pb-2 fs-5 px-4"
                      >
                        Signup Now
                      </Button>
                      {/* <img
                        src={GoogleAuth}
                        alt="Google Authentication"
                        className="w-100 my-3 img-fluid"
                      /> */}
                      <div className="d-flex justify-content-center py-4 pb-0">
                        <span className="text-black text-center mx-2">
                          Already have an account?
                        </span>
                        <span
                          className="text-primary cursor-pointer"
                          onClick={handleSignIn}
                        >
                          Sign In
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 rounded-end-2 d-none d-md-flex bg-image"></div>
        </div>
      </div>
      <div className="position-absolute p-5 bottom-0 end-0 z-n1 redOval rounded-circle"></div>
      {/* <ToastContainer /> */}
    </Modal>
  );
}
